import EmojiRegex from 'emoji-regex';

const regex = EmojiRegex();

export function getFirstEmoji(input) {
  if (!input) return;

  return input.match(regex)?.[0];
}
